<template>
  <div class="home">
    <InfoUser v-on:changeActiveCard='data=> emitToParent("changeActiveCard",this,data)' v-on:userData='data =>emitToParent("userData",this,data)' v-bind="userData"/>
    <div class="innerContainer"  v-if="userData2">
      <FormRecarga v-on:openPopup="data=>emitToParent('openPopup',this,data)" v-on:update-card="reloadUser" v-if="!sucessRecarga" v-on:sucessRecarga='sucessRecarga = true' v-bind="userData2"/>
      <div class="gifRecarga" v-else>
      <span>Recebemos seu pedido! Após a aprovação do seu pedido, valide sua recarga online nas nossas estações!</span>
       <img src="../assets/img/pedido-confirmacao.gif">
      </div>
      <ModalCartaoDesassociado :open="modalCardDissociated"/>
      <ModalNovosTermos/>
      <RightColumnAds :images="banners"/>
    </div>
    <div v-else class="innerContainer">
      <p style="text-align: center">Carregando...</p>
    </div>
  </div>
</template>
<style lang="scss">
.gifRecarga{
    display: inline-block;
    width: 62%;
    text-align: center;
    span{
      padding-right:16%;
    }
    img{ 
        width: 100%;
    }
}
@media screen and (max-width: 767px) {  
  .gifRecarga{
    text-align: center;
    display: block;
    width: 100%;
    img{
        width: 100% !important;
    }
    span{
      padding-right: 0;
    }
  }
}

</style>
<script>
import RightColumnAds from '@/components/RightColumnAds.vue'
import InfoUser from '@/components/InfoUser.vue'
import FormRecarga from '@/components/FormRecarga.vue'
import ModalNovosTermos from '@/components/ModalNovosTermos.vue'
import ModalCartaoDesassociado from '@/components/ModalCartaoDesassociado.vue'
import {resolvePromise, emitToParent,scrollTop, redirect} from '../helpers/helpers'
 import {get} from '../services/image.service'
  import {myUser} from '../services/user.service'
export default {
  name: 'home',
  props:{
    userData:{
      type:Object
    },
   /*imagesObject:{
      type:Object
    },*/
    sucessRecarga:{
      type:Boolean,
      default:false
    }
  },
  components: {
    RightColumnAds,
    InfoUser,
    ModalNovosTermos,
    ModalCartaoDesassociado,
    FormRecarga
  },
  data() {
    return {
      modalCardDissociated: false,
      banners: [],
      userData2: null
    }
  },
  methods:{
    emitToParent,
    loadBanner: function() {
      get("Home").then(r => {
          this.banners = r.data.sort((a, b) => a.position - b.position);
      })
    },
    reloadUser: function() {
      resolvePromise(myUser(),({data})=> { this.userData2 = data; },err => {
        if(err == 'CARD-DISSOCIATED') {
          //emitToParent('cardDissociated', this, true);
          this.modalCardDissociated = true;
          resolvePromise(myUser(),({data})=> { this.userData2 = data; },err => console.log(err));
        }
      },this);
    },
    _mount() {
      resolvePromise(myUser(),({data})=> { this.userData2 = data; },(err) => {
        if(err == 'CARD-DISSOCIATED') {
          this.modalCardDissociated = true;
          //emitToParent('cardDissociated', this, true);
          this._mount();
        } else {
          console.log(err);
        }
      },this);
    }
  },
  created(){
    if(!sessionStorage.getItem("giro-token")) redirect("login",this)
    //emitToParent("getImage",this,"Home")
    scrollTop()
    this.loadBanner();
    this._mount();
  }
}
</script>
